import { defineComponent } from "vue";
import CameraIcon from "@/assets/shared/icons/camera.svg";

export default defineComponent({
  data() {
    return {
      hasError: false,
      imagePath: null,
      cameraIconPath: CameraIcon
    };
  },
  methods: {
    isAllowedImageFile(file: File): boolean {
      if (!file) {
        return false;
      }

      if (typeof file.type === "string" && file.type.toLowerCase().startsWith("image/")) {
        return true;
      }

      const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".heic", ".heif"];
      const fileName = (file.name || "").toLowerCase();
      return allowedExtensions.some(extension => fileName.endsWith(extension));
    },

    pictureChanged(event: any) {
      const files = event?.target?.files;
      const file = files && files[0];

      if (!this.isAllowedImageFile(file)) {
        this.hasError = true;
        this.imagePath = null;
        if (event?.target) {
          event.target.value = "";
        }
        this.$emit("imageChanged", "");
        return;
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imagePath = fileReader.result as any;
        this.hasError = false;
        this.$emit("imageChanged", this.imagePath);
      });
      fileReader.readAsDataURL(file);
    },
    takePictureAgain() {
      this.imagePath = null;
      this.$emit("imageChanged", "");
    },
  },
});
